// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { ExecutedUnfreeze } from '@daml.js/dtc-registry/lib/Dtc/Registry/V3/Model/MarkerEvents';
import { TemplateHistory, useTemplateHistory } from '../../useTemplateHistory';

const useExecutedUnfreezes = (): TemplateHistory<ExecutedUnfreeze> =>
  useTemplateHistory(ExecutedUnfreeze);

export default useExecutedUnfreezes;
